import getQueryString from 'Common/getQueryString';
import { getDisplay, getAndFormat } from 'Common/formValues';
import * as R from 'ramda';
// This is for retaining the filter in url while creating the query from the filter form.
// It is used for nearly new deals - linked from whatcar reviews page
const extraParamsFromUrl = ['minOdometerReadingMiles', 'minPlate', 'maxPlate'];

export default (form, urlParams = '') => {
  const values = form.values;
  let queryItems = getQueryString(form).split('&');
  let url;
  if (values.dealerId) {
    url = 'dealer/' + getDisplay(values.dealerId);
    queryItems = queryItems.filter(i => !R.startsWith('dealer.id', i));
  } else {
    if (values.make) {
      url = getAndFormat(values.make);
      queryItems = queryItems.filter(i => !R.startsWith('standardMake', i));
    } else {
      url = 'all';
    }
    if (values.model) {
      url = url + '/' + getAndFormat(values.model);
      queryItems = queryItems.filter(i => !R.startsWith('standardModel', i));
    }

    if (values.category && !values.make && !values.model) {
      url = getAndFormat(values.category);
      queryItems = queryItems.filter(
        i => !R.startsWith('derivative.category', i)
      );
    }
    // Remove undefined or null postcode from query
    if (!values.postcode) {
      queryItems = queryItems.filter(i => !R.startsWith('postcode', i));
    }
  }

  queryItems = queryItems.filter(
    i => !(R.startsWith('lat', i) || R.startsWith('long', i))
  );

  extraParamsFromUrl.map(i => {
    const value = urlParams && urlParams.get(i);
    if (value) {
      queryItems.push(`${i}=${value}`);
    }
  });
  const query = queryItems.join('&');

  return '/used-cars/' + url + '?' + query;
};



// WEBPACK FOOTER //
// ./src/Common/buildUrlFromForm/index.js